import { get_generation_current_generation_price } from '@/utils/UTILS__generation';
import { useMemo } from 'react';
import { use_slice_generation, use_slice_generation_price, use_slice_grid2d } from './store/use_slices';

export function use_generation_current_price(skip_generated_images: boolean) {
  const { generation_prices_by_hashes_map } = use_slice_generation_price(['generation_prices_by_hashes_map']);
  const { grids2d_map, grid2d_chunk_cells_loading_in_progress } = use_slice_grid2d(['grid2d_chunk_cells_loading_in_progress', 'grids2d_map']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const price = useMemo(
    () => get_price(),
    [generation_current, grids2d_map, grid2d_chunk_cells_loading_in_progress, generation_prices_by_hashes_map, skip_generated_images],
  );

  /*
   * EFFECTS
   */
  function get_price() {
    //todo:remove
    return 1;

    //need to check here to avoid glitch on page generation when we removed grid2d from grid2d_map and price drops to 0
    if (!grids2d_map.has(generation_current._id)) return NaN; //grid2d not loaded yet

    let value = get_generation_current_generation_price(skip_generated_images);

    return value;
  }

  return { generation_current_price: price };
}
